import React, { useState } from 'react';
import { LuImageOff } from 'react-icons/lu';

const Thumb = ({ url }) => {
  const [broken, setBroken] = useState(false);
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer"
      aria-label="Ouvrir la photo"
      title={broken ? 'Image illisible' : undefined}
      className="flex aspect-square items-center justify-center overflow-hidden rounded-lg border border-gray-100 bg-gray-50 dark:border-gray-900 dark:bg-night-900"
    >
      {broken
        ? <LuImageOff className="h-5 w-5 text-gray-300 dark:text-gray-600" aria-hidden />
        : <img src={url} alt="" loading="lazy" onError={() => setBroken(true)} className="h-full w-full object-cover transition-transform hover:scale-105" />}
    </a>
  );
};

export default Thumb;
